var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8889 4.16699H3.11111C1.94518 4.16699 1 5.11217 1 6.2781V17.8892C1 19.0551 1.94518 20.0003 3.11111 20.0003H17.8889C19.0548 20.0003 20 19.0551 20 17.8892V6.2781C20 5.11217 19.0548 4.16699 17.8889 4.16699Z",
    stroke: "#616161",
    strokeWidth: 1.05556
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.38921C1 6.39844 1 5.4041 1.61856 4.78555C2.23711 4.16699 3.23144 4.16699 5.22222 4.16699H15.7778C17.7686 4.16699 18.7629 4.16699 19.3814 4.78555C20 5.4041 20 6.39844 20 8.38921H1Z",
    fill: "#616161"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.22241 1V4.16667M15.778 1V4.16667",
    stroke: "#616161",
    strokeWidth: 1.05556,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDates);
export default __webpack_public_path__ + "static/media/dates.67738d94f0fd7df39d3a8f9ae9c9674d.svg";
export { ForwardRef as ReactComponent };